import { defineStore } from "pinia";
import { FinancesService } from "@core/services/webmaster/finances/FinancesService";
import { FinancePayout } from "@core/store/types/webmaster/finances/modal/financePayout";
import vuexStore from "@/store";

export const usePayoutStore = defineStore("webmaster/payoutStore", {
  state: (): FinancePayout => ({
    input: {
      requisiteId: null,
      amount: null
    }
  }),

  getters: {},

  actions: {
    async ORDER_PAYMENT () {
      const { data: { orderOutTransaction } } = await FinancesService.addFinances(this.input);
      vuexStore.commit("webmaster/finances/LOCAL_ADD", { items: orderOutTransaction });
    }
  }
});